__turbopack_context__.v({
  "checkbox": "dashboard-visual-module__ClkIJa__checkbox",
  "checkboxDone": "dashboard-visual-module__ClkIJa__checkboxDone",
  "dayBody": "dashboard-visual-module__ClkIJa__dayBody",
  "dayFigure": "dashboard-visual-module__ClkIJa__dayFigure",
  "dayFill": "dashboard-visual-module__ClkIJa__dayFill",
  "dayHead": "dashboard-visual-module__ClkIJa__dayHead",
  "dayPlanned": "dashboard-visual-module__ClkIJa__dayPlanned",
  "dayTrack": "dashboard-visual-module__ClkIJa__dayTrack",
  "grid": "dashboard-visual-module__ClkIJa__grid",
  "leadDays": "dashboard-visual-module__ClkIJa__leadDays",
  "plot": "dashboard-visual-module__ClkIJa__plot",
  "root": "dashboard-visual-module__ClkIJa__root",
  "taskClient": "dashboard-visual-module__ClkIJa__taskClient",
  "taskDone": "dashboard-visual-module__ClkIJa__taskDone",
  "trendArea": "dashboard-visual-module__ClkIJa__trendArea",
  "trendDone": "dashboard-visual-module__ClkIJa__trendDone",
  "trendMarker": "dashboard-visual-module__ClkIJa__trendMarker",
  "trendPlanned": "dashboard-visual-module__ClkIJa__trendPlanned",
  "trendSvg": "dashboard-visual-module__ClkIJa__trendSvg",
  "trendTip": "dashboard-visual-module__ClkIJa__trendTip",
  "trendWrap": "dashboard-visual-module__ClkIJa__trendWrap",
  "widget": "dashboard-visual-module__ClkIJa__widget",
  "widgetVisible": "dashboard-visual-module__ClkIJa__widgetVisible",
});
